/* =========================================================
   LOMSIR First Version Theme Layer
   Mobile-first / GEO-ready / Supplement Brand System
   File: assets/lomsir.js
   ========================================================= */

(function () {
  'use strict';

  var LOMSIR = {
    selectors: {
      faqItem: '.lomsir-faq__item',
      faqQuestion: '.lomsir-faq__question',
      stickyAtc: '.lomsir-sticky-atc',
      stickyAtcTrigger: '[data-lomsir-atc-trigger]',
      stickyAtcButton: '[data-lomsir-sticky-atc-button]',
      mainProductForm: 'form[action*="/cart/add"]',
      tabButton: '[data-lomsir-tab-button]',
      tabPanel: '[data-lomsir-tab-panel]',
      smoothLink: 'a[href^="#"]'
    },

    classes: {
      open: 'is-open',
      visible: 'is-visible',
      active: 'is-active'
    },

    init: function () {
      this.initFaq();
      this.initStickyAtc();
      this.initTabs();
      this.initSmoothScroll();
      this.initThemeEditorEvents();
    },

    /* ------------------------------
       FAQ Accordion
       ------------------------------ */

    initFaq: function () {
      var questions = document.querySelectorAll(this.selectors.faqQuestion);

      if (!questions.length) return;

      questions.forEach(function (question) {
        question.addEventListener('click', function () {
          var item = question.closest(LOMSIR.selectors.faqItem);
          if (!item) return;

          var isOpen = item.classList.contains(LOMSIR.classes.open);
          var answer = item.querySelector('.lomsir-faq__answer');

          item.classList.toggle(LOMSIR.classes.open, !isOpen);
          question.setAttribute('aria-expanded', String(!isOpen));

          if (answer) {
            answer.hidden = isOpen;
          }
        });
      });
    },

    /* ------------------------------
       Mobile Sticky Add to Cart
       ------------------------------ */

    initStickyAtc: function () {
      var stickyAtc = document.querySelector(this.selectors.stickyAtc);
      if (!stickyAtc) return;

      var trigger = document.querySelector(this.selectors.stickyAtcTrigger);
      var stickyButton = document.querySelector(this.selectors.stickyAtcButton);

      if (!trigger) {
        stickyAtc.classList.add(this.classes.visible);
      } else if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                stickyAtc.classList.remove(LOMSIR.classes.visible);
              } else {
                stickyAtc.classList.add(LOMSIR.classes.visible);
              }
            });
          },
          {
            root: null,
            threshold: 0.1
          }
        );

        observer.observe(trigger);
      } else {
        stickyAtc.classList.add(this.classes.visible);
      }

      if (stickyButton) {
        stickyButton.addEventListener('click', function (event) {
          var productForm = document.querySelector(LOMSIR.selectors.mainProductForm);

          if (!productForm) return;

          event.preventDefault();

          var submitButton = productForm.querySelector(
            'button[type="submit"], input[type="submit"]'
          );

          if (submitButton && !submitButton.disabled) {
            submitButton.click();
          }
        });
      }
    },

    /* ------------------------------
       Product Tabs
       ------------------------------ */

    initTabs: function () {
      var tabButtons = document.querySelectorAll(this.selectors.tabButton);
      var tabPanels = document.querySelectorAll(this.selectors.tabPanel);

      if (!tabButtons.length || !tabPanels.length) return;

      tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-lomsir-tab-button');

          if (!target) return;

          tabButtons.forEach(function (btn) {
            var isActive = btn === button;
            btn.classList.toggle(LOMSIR.classes.active, isActive);
            btn.setAttribute('aria-selected', String(isActive));
          });

          tabPanels.forEach(function (panel) {
            var isTarget = panel.getAttribute('data-lomsir-tab-panel') === target;
            panel.classList.toggle(LOMSIR.classes.active, isTarget);
            panel.hidden = !isTarget;
          });
        });
      });
    },

    /* ------------------------------
       Smooth Anchor Scroll
       ------------------------------ */

    initSmoothScroll: function () {
      var links = document.querySelectorAll(this.selectors.smoothLink);

      if (!links.length) return;

      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var href = link.getAttribute('href');

          if (!href || href === '#') return;

          var target = document.querySelector(href);

          if (!target) return;

          event.preventDefault();

          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      });
    },

    /* ------------------------------
       Shopify Theme Editor Support
       ------------------------------ */

    initThemeEditorEvents: function () {
      document.addEventListener('shopify:section:load', function () {
        LOMSIR.initFaq();
        LOMSIR.initStickyAtc();
        LOMSIR.initTabs();
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      LOMSIR.init();
    });
  } else {
    LOMSIR.init();
  }
})();